import React from 'react';
import { ConfiguratorPresetGroupDto } from '@/services/configurator';
import { RoomStyleGroupCard } from './RoomStyleGroupCard';

export interface RoomStyleProps {
    stylesGroups: ConfiguratorPresetGroupDto[];
}

export const RoomStyle: React.FC<RoomStyleProps> = ({ stylesGroups }) => {
    return (
        <>
            {stylesGroups.map((styleGroup) => (
                <RoomStyleGroupCard key={styleGroup.id} styleGroup={styleGroup} />
            ))}
        </>
    );
};
